import Vue from 'vue';
import VueRouter from 'vue-router';

import Error4040View from '../view/pages/Error404.vue';
import Error4030View from '../view/pages/Error403.vue';
import ProfileView from '../view/pages/profile/profile.vue';

import DashboardView from '../view/pages/dashboard/dashboard.vue';
import TypeContract from '../view/pages/master/typeContract/typeContract.vue';
import role from '../view/pages/master/role/Role.vue';
import listContract from '../view/pages/listContract/listContract.vue';
import contractDetails from '../view/pages/listContract/detailContract.vue';
import notificationSettings from '../view/pages/notification_settings/notificationSettings.vue';
import historicalLogContract from '@/view/pages/listContract/historicalLogContract.vue';
import user from '../view/pages/master/users/Users.vue';
import organization from '@/view/pages/master/organization/Organization.vue';
import { authorize } from '../utils/authorize';

Vue.use(VueRouter);

const authGuard = (path) => async (to, from, next) => {
	try {
		if (await authorize(path, 'read')) {
			next();
		} else {
			console.warn(`Authorization failed for path: ${path}. Dipsplay 403 page.`);
			next({
				// path: to.fullPath,
				name: 'Error403',
				// component: Error4030View,
			});
		}
	} catch (error) {
		console.error(`Error during authorization for path ${path}:`, error);
		next({
			// path: to.fullPath,
			name: 'Error403',
			// component: Error4030View,
		});
	}
};

const routes = [
	{
		path: '/',
		name: 'Dashboard',
		component: DashboardView,
		beforeEnter: authGuard('/'),
	},
	{
		path: '/type-of-contract',
		name: 'Type Contract',
		component: TypeContract,
		beforeEnter: authGuard('/type-of-contract'),
	},
	{
		path: '/role',
		name: 'Role',
		component: role,
		beforeEnter: authGuard('/role'),
	},
	{
		path: '/users',
		name: 'Users',
		component: user,
		beforeEnter: authGuard('/users'),
	},
	{
		path: '/organization',
		name: 'Organization',
		component: organization,
		beforeEnter: authGuard('/organization'),
	},
	{
		path: '/listContract',
		name: 'ListContract',
		component: listContract,
		beforeEnter: authGuard('/listContract'),
	},
	{
		path: '/listContract/:id',
		name: 'ListContractDetail',
		component: listContract,
		beforeEnter: authGuard('/listContract'),
	},
	{
		path: '/listContract/:id/details',
		name: 'DetailsContract',
		component: contractDetails,
		beforeEnter: authGuard('/listContract'),
	},
	{
		path: '/listContract/:id/historical-log',
		name: 'HistoricalLog',
		component: historicalLogContract,
		beforeEnter: authGuard('/listContract'),
	},
	// {
	// 	path: '/role-management',
	// 	name: 'RoleManagement',
	// 	component: RoleManagementView,
	// 	beforeEnter: async (to, from, next) => {
	// 		if (await authorize('/role-management', 'read')) {
	// 			next();
	// 		} else {
	// 			next({ name: 'Error403' });
	// 		}
	// 	},
	// },
	{
		path: '/notification-setting',
		name: 'notificationSetting',
		component: notificationSettings,
		beforeEnter: authGuard('/notification-setting'),
	},
	{
		path: '/profile',
		name: 'Profile',
		component: ProfileView,
	},
	{
		path: '*',
		name: 'Error404',
		component: Error4040View,
	},
	{
		path: '/403',
		name: 'Error403',
		component: Error4030View,
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
